var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("status-badge status-badge__" + _vm.status + " rounded-full w-2.5 h-2.5 mr-0.5 rtl:mr-0 rtl:ml-0.5 inline-flex")})}
var staticRenderFns = []

export { render, staticRenderFns }